import * as Yup from "yup";
import { ICustomInputProps } from "../interfaces/form";

type YupBoolean = Yup.BooleanSchema<boolean | undefined, Yup.AnyObject, boolean | undefined>
type YupString = Yup.StringSchema<string | undefined, Yup.AnyObject, string | undefined>
type YupArrayString = Yup.ArraySchema<string[] | undefined, Yup.AnyObject, string | undefined>

export const generateValidations = (field: ICustomInputProps) => {

    if (!field.validations) return null

    let schema: YupBoolean | YupString | YupArrayString = field.typeValue !== 'array' ? Yup[field.typeValue || "string"]() : Yup[field.typeValue]()

    for (const rule of field.validations) {
        switch (rule.type) {
            case 'isArrayRequired': schema = (schema as YupArrayString).required(rule.message); break;
            case 'requiredCheck': schema = (schema as YupString).oneOf(["true"], rule.message).required(rule.message); break;
            case 'isTrue': schema = (schema as YupBoolean).required(rule.message); break;
            case 'requiredIfChecked': schema = (schema as YupString).when("beehiveAssigned", (beehiveAssigned, schema) => beehiveAssigned[0] === "true" ? schema.required(rule.message) : schema); break;
            case 'confirmPassword': schema = (schema as YupString).oneOf([Yup.ref('password'), ""], rule.message); break;
            case 'confirmNewPassword': schema = (schema as YupString).oneOf([Yup.ref('newPassword'), ""], rule.message); break;
            case 'isEmail': schema = (schema as YupString).email(rule.message); break;
            case 'min': schema = (schema as YupString).min(rule?.value as number, rule.message); break;
            case 'minLength': schema = (schema as YupString).min(rule?.value as number, rule.message); break;
            case 'maxLength': schema = (schema as YupString).max(rule?.value as number, rule.message); break;
            case 'oneOf': schema = (schema as YupString).oneOf([Yup.ref((rule as any).ref)], rule.message); break;
            case 'pattern': schema = (schema as YupString).matches(new RegExp(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[@$!%*?&])[A-Za-z0-9@$!%*?&]{0,}$/g), rule.message); break;
            default: schema = schema.required(rule.message); break;
        }
    }

    return schema;

}